import { render } from "./SelectStores.vue?vue&type=template&id=2764bda4"
import script from "./SelectStores.vue?vue&type=script&lang=js"
export * from "./SelectStores.vue?vue&type=script&lang=js"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__